var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useCallback, useEffect, useState } from 'react';
import { api, getBackendUrl } from '../api';
var getUpdatedPartnerConfig = function (primaryConfig, secondaryConfig) {
    return __assign(__assign(__assign({}, secondaryConfig), primaryConfig), { icons: __assign(__assign({}, secondaryConfig.icons), primaryConfig.icons), preview: __assign(__assign({}, secondaryConfig.preview), primaryConfig.preview), borderRadius: __assign(__assign({}, secondaryConfig.borderRadius), primaryConfig.borderRadius), colors: __assign(__assign({}, secondaryConfig.colors), primaryConfig.colors), fonts: __assign(__assign({}, secondaryConfig.fonts), primaryConfig.fonts), containerStyle: __assign(__assign({}, secondaryConfig.containerStyle), primaryConfig.containerStyle), showDelaySeconds: primaryConfig.showDelaySeconds || secondaryConfig.showDelaySeconds, previewDelaySeconds: primaryConfig.previewDelaySeconds || secondaryConfig.previewDelaySeconds, partnerId: primaryConfig.partnerId || secondaryConfig.partnerId, webChatUrl: primaryConfig.webChatUrl || secondaryConfig.webChatUrl, defaultLanguageCode: primaryConfig.defaultLanguageCode || secondaryConfig.defaultLanguageCode });
};
export var usePartnerConfig = function () {
    var _a = useState(window.__ET || {}), partnerConfig = _a[0], setPartnerConfigInner = _a[1];
    var _b = useState(false), isConfigLoaded = _b[0], setConfigLoaded = _b[1];
    var _c = useState(false), hasServerConfig = _c[0], setHasServerConfig = _c[1];
    var backendUrl = getBackendUrl(partnerConfig.webChatUrl);
    var updatePartnerConfig = function (partnerId) { return __awaiter(void 0, void 0, void 0, function () {
        var response, data, newPartnerConfig, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 4, 5, 6]);
                    return [4 /*yield*/, api.getPartnerConfig(backendUrl, partnerId)];
                case 1:
                    response = _a.sent();
                    if (!(response.status === 200)) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _a.sent();
                    newPartnerConfig = data;
                    if (newPartnerConfig.enforceServerConfig) {
                        setPartnerConfigInner(getUpdatedPartnerConfig(newPartnerConfig, partnerConfig));
                    }
                    else {
                        setPartnerConfigInner(getUpdatedPartnerConfig(partnerConfig, newPartnerConfig));
                    }
                    setHasServerConfig(true);
                    _a.label = 3;
                case 3: return [3 /*break*/, 6];
                case 4:
                    e_1 = _a.sent();
                    return [3 /*break*/, 6];
                case 5:
                    setConfigLoaded(true);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (!partnerConfig.partnerId) {
            setConfigLoaded(true);
            return;
        }
        updatePartnerConfig(partnerConfig.partnerId);
    }, [partnerConfig.partnerId]);
    var setPartnerConfig = useCallback(function (config) {
        setPartnerConfigInner(getUpdatedPartnerConfig(config, partnerConfig));
    }, [partnerConfig]);
    return { partnerConfig: partnerConfig, setPartnerConfig: setPartnerConfig, isConfigLoaded: isConfigLoaded, setConfigLoaded: setConfigLoaded, hasServerConfig: hasServerConfig };
};
